import { render, staticRenderFns } from "./ServiceRequestAttachmentModal.vue?vue&type=template&id=167d1e4b&scoped=true"
import script from "./ServiceRequestAttachmentModal.vue?vue&type=script&lang=js"
export * from "./ServiceRequestAttachmentModal.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestAttachmentModal.vue?vue&type=style&index=0&id=167d1e4b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167d1e4b",
  null
  
)

export default component.exports